import { FormGroup } from "@blueprintjs/core";
import { SignatureComponent } from "@syncfusion/ej2-react-inputs";
import _ from "lodash";
import { FormFieldErrorContainer } from "../../CoreFields/FieldError/FormFieldErrorContainer";
import { FieldLabel } from "../../CoreFields/FieldLabel/FieldLabel";
import { FieldLabeledProps, SignatureProps } from "../../types/fieldTypes";
import { useSignatureField } from "./useSignatureField";
import { signaturePNGBackground } from "./utils";
import { SecondaryButton } from "../../../Buttons";

export interface SignatureFieldProps extends SignatureProps {
  labelProps?: FieldLabeledProps;
}

const SignatureField: React.FC<SignatureFieldProps> = (props) => {
  const {
    signatureComponent,
    localDisabled,
    setLocalDisabled,
    undoDisabled,
    setUndoDisabled,
    clearDisabled,
    setClearDisabled,
    submitValue,
    getValue,
  } = useSignatureField(props);

  return (
    <div className="ucl-special-input-signature-field-container">
      <FormGroup
        className={`${
          props.isRequired && !signatureComponent.current
            ? "has-required-background signature-input-field"
            : "base-field signature-input-field"
        }`}
      >
        <section className="signature-action-button-section">
          {props.label && (
            <FieldLabel
              labelName={props.label}
              tooltipDescription={props.description}
              fieldProps={{ ...props, value: getValue() }}
              isRequired={props.isRequired}
              {...props.labelProps}
            />
          )}
          <SecondaryButton
            text="Undo"
            disabled={localDisabled || undoDisabled}
            onClick={() => {
              if (signatureComponent.current) {
                // We need to wait until the new images is loaded on the canvas, unfortunately, we don't have a way to
                //  attach an event to the library on that specific section.
                signatureComponent.current.undo();
                setLocalDisabled(true);

                setTimeout(() => {
                  setLocalDisabled(false);
                  submitValue();
                }, 300);
              }
            }}
          />
          <SecondaryButton
            text="Clear"
            disabled={localDisabled || clearDisabled}
            onClick={() => signatureComponent.current?.clear()}
          />
        </section>
        <SignatureComponent
          disabled={localDisabled}
          ref={signatureComponent}
          backgroundImage={signaturePNGBackground}
          saveWithBackground={false}
          change={() => {
            setUndoDisabled(!signatureComponent.current?.canUndo());
            setClearDisabled(signatureComponent.current?.isEmpty());
            submitValue();
          }}
        />
      </FormGroup>
      {props.errorMessages && (
        <FormFieldErrorContainer errorMessages={props.errorMessages} />
      )}
    </div>
  );
};

export default SignatureField;
